<template>
    <div v-show="message">
        <p v-if="typeof message === 'string'" class="truncate text-xs text-red-600">
            {{ message }}
        </p>
        <p v-else class="text-xs text-red-600" v-for="m of message">
            {{ m }}
        </p>
    </div>
</template>

<script>
export default {
    props: ['message']
}
</script>
